<div class="container">
  <button
    type="button"
    class="text-uppercase close"
    mat-button
    [mat-dialog-close]="true"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div fxLayout="row">
    <mat-icon class="error">error_outline</mat-icon>
    <h1 mat-dialog-title>Unable to import this row</h1>
  </div>
  <mat-dialog-content
    >Please correct the following {{ data.errors.length }} error(s) and
    re-upload your CSV.
    <ul>
      @for (dataError of data.errors; track dataError) {
        <li>
          {{ format(dataError?.message) }}
        </li>
      }
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions>
    <a mat-flat-button class="primary" [mat-dialog-close]="true"> Close </a>
  </mat-dialog-actions>
</div>
